import useTracking from './use-tracking';

export default function useTrackPageView() {
  const track = useTracking();

  return (pageId: string, path: string, extraPayload?: { [key: string]: any }) => {
    track('page-viewed', {
      path,
      page_id: pageId,
      href: window.location.href,
      title: document.title,
      ...extraPayload
    });
  };
}
